module.exports = __webpack_public_path__ + "img/vertical_3_4_9006.c5d06dc8.png";